import React from 'react';
import './renovacaoDocumentos.scss';
import '../../components/breadcrumbs/breadcrumbs.scss';
import FileUpload from '../../components/fileUpload';
import Table from '../../components/table';
import { tipoDocImagem } from '../../helper/constants';
import { Axios } from "../../service/serviceBasic";

//Componentes
import Label from '../../components/label';
import Loading from "../../components/loading";

const TipoPessoa = {
  PessoaFisica: 1,
  PessoaJuridica: 2,
  PessoaFisicaSemCPF: 3,
}

const InitialState = {
  files: [],
  filesError: [],
  inputsLoading: {
    IdTipoDocumento: 0,
    Verso: false
  }
}

class RenovacaoDocumentos extends React.Component {

  state = InitialState;

  componentDidMount() {
    this.formFields = [];
    this.input = [];

    const { match, listDocumentosSolicitadosAction, history } = this.props;
    const params = match.params;

    if (params && params.id) {
      listDocumentosSolicitadosAction(params.id, history);
    } else {
      history.push("/");
    }
  }

  handleChangeFile = async (element) => {

    let newFilesError = this.state.filesError.filter(x => x.IdTipoDocumento !== element.documentType || x.Verso !== (element.imageType === tipoDocImagem.Verso))
    this.setState({...this.state, newFilesError, inputsLoading: {IdTipoDocumento: element.documentType, Verso: element.imageType === tipoDocImagem.Verso}}); 

    if (!element.base64 && element.deleteAll) {
      const newStateFiles = this.state.files.filter(x => x.IdTipoDocumento !== element.documentType || x.Verso !== (element.imageType === tipoDocImagem.Verso));
      this.setState({...this.state, files: newStateFiles, filesError: newFilesError, inputsLoading: InitialState.inputsLoading})

    } else if (element.errorNotification && element.errorNotification !== "") {
      const fileError = {
        IdTipoDocumento: element.documentType,
        Verso: element.imageType === tipoDocImagem.Verso,
        Msg: element.errorNotification
      }
      newFilesError = newFilesError.concat(fileError);
      this.setState({...this.state, filesError: newFilesError, inputsLoading: InitialState.inputsLoading});

    } else if (element.base64 && 
      this.state.files.find(x => x.Base64 === element.base64 && x.IdTipoDocumento === element.typeDocument && x.Verso === (element.imageType === tipoDocImagem.Verso)) === undefined) {
      const {documentosSolicitados} = this.props.renovacaoDocumentos;
      const resultUpload = await this.uploadDocumento(element);
      if (resultUpload !== undefined && !resultUpload.ErrorMsg) {
        const file = {  
          NotificacaoCliente_Id: documentosSolicitados[0].NotificacaoCliente_Id,
          Base64: element.base64,
          IdTipoDocumento: element.documentType,
          Nome: element.text,
          TipoArquivo: element.fileType.toLowerCase() === "jpeg" ? "jpg" : element.fileType.toLowerCase(),
          Arquivo: element.value,
          DuasFaces: element.imageType === tipoDocImagem.Frente || element.imageType === tipoDocImagem.Verso, // tipo frente ou verso
          Verso: element.imageType === tipoDocImagem.Verso,
          IdPessoa: documentosSolicitados[0].IdPessoa,
          text: element.text,
          IdDocumentoArquivo: resultUpload.IdDocumentoArquivo
        }
        const newStateFile = this.state.files.concat(file);
        this.setState({ ...this.state, files:newStateFile, filesError: newFilesError, inputsLoading: InitialState.inputsLoading});

      } else {
        const fileError = {
          IdTipoDocumento: element.documentType,
          Verso: element.imageType === tipoDocImagem.Verso,
          Msg: "Seu documento não foi enviado. Tente novamente."
        }
        newFilesError = newFilesError.concat(fileError);
        this.setState({...this.state, filesError: newFilesError, inputsLoading: InitialState.inputsLoading});

      }     
    }
  }

  findFile = (item, verso = false) => {
    return this.state.files.find(x => x.IdTipoDocumento === item.IdTipoDocumento && 
      x.Verso === verso)
  }

  filterFiles = (item, verso = false) => {
    return this.state.files.filter(x => x.IdTipoDocumento === item.IdTipoDocumento && 
      x.Verso === verso)
  }

  deleteFile = (file) => {
    const newStateFiles = this.state.files.filter(x => x.Base64 !== file.Base64 || x.IdTipoDocumento !== file.IdTipoDocumento || x.Verso !== file.Verso);
    this.setState({...this.state, files: newStateFiles})
  }

  enviar = () => {
    const {tiposDocumentoSolicitados, documentosSolicitados, tiposDocObrigatoriosOpcionais} = this.props.renovacaoDocumentos;
    const {enviarArquivos, history} = this.props;

    let filesError1 = [];
    let fileError = {};
    for (var x = 0; x < tiposDocumentoSolicitados.length; x++) {
      let fileFound = this.findFile(tiposDocumentoSolicitados[x]);
      // eslint-disable-next-line no-loop-func
      const doc = documentosSolicitados.find(y => y.Documentacao_Id === tiposDocumentoSolicitados[x].CodigoProcam);
      
      if (fileFound === undefined && doc.Obrigatorio) {
        fileError = {
          IdTipoDocumento: tiposDocumentoSolicitados[x].IdTipoDocumento,
          Verso: false,
          Msg: `${tiposDocumentoSolicitados[x].DuasFaces ? "Frente do " : ""}${tiposDocumentoSolicitados[x].Descricao} obrigatório!`
        }
        filesError1 = filesError1.concat(fileError);
      }

      if (tiposDocumentoSolicitados[x].DuasFaces) {
        fileFound = this.findFile(tiposDocumentoSolicitados[x], true);

        if (fileFound === undefined && doc.Obrigatorio) {
          fileError = {
            IdTipoDocumento: tiposDocumentoSolicitados[x].IdTipoDocumento,
            Verso: true,
            Msg: `Verso do ${tiposDocumentoSolicitados[x].Descricao} obrigatório!`
          }
          filesError1 = filesError1.concat(fileError);
        }
      }
    }   

    if (filesError1.length > 0) {
      if (tiposDocObrigatoriosOpcionais.length > 0) {
        let filesError2 = [];
        let fileError = {};
        for (var y = 0; y < tiposDocObrigatoriosOpcionais.length; y++) {
          let fileFound = this.findFile(tiposDocObrigatoriosOpcionais[y]);
          // eslint-disable-next-line no-loop-func
          const doc = documentosSolicitados.find(z => z.Documentacao_Id === tiposDocObrigatoriosOpcionais[y].CodigoProcam);
          
          if (fileFound === undefined && doc.Obrigatorio) {
            fileError = {
              IdTipoDocumento: tiposDocObrigatoriosOpcionais[y].IdTipoDocumento,
              Verso: false,
              Msg: `${tiposDocObrigatoriosOpcionais[y].DuasFaces ? "Frente do " : ""}${tiposDocObrigatoriosOpcionais[y].Descricao} obrigatório!`
            }
            filesError2 = filesError2.concat(fileError);
          }
    
          if (tiposDocObrigatoriosOpcionais[y].DuasFaces) {
            fileFound = this.findFile(tiposDocObrigatoriosOpcionais[y], true);
    
            if (fileFound === undefined && doc.Obrigatorio) {
              fileError = {
                IdTipoDocumento: tiposDocObrigatoriosOpcionais[y].IdTipoDocumento,
                Verso: true,
                Msg: `Verso do ${tiposDocObrigatoriosOpcionais[y].Descricao} obrigatório!`
              }
              filesError2 = filesError2.concat(fileError);
            }
          }
        }

        if (filesError2.length > 0) {
          filesError2 = filesError2.concat(filesError1);
          this.setState({...this.state, filesError: filesError2})
          return;
        }
      } else {
        this.setState({...this.state, filesError: filesError1})
        return;
      }      
    }
    
    let files = [];
    this.state.files.map(x => {
      const file = {  
        NotificacaoCliente_Id: x.NotificacaoCliente_Id,
        IdPessoa: x.IdPessoa,
        IdDocumentoArquivo: x.IdDocumentoArquivo,
      }
      files = files.concat(file);
      return x;
    })     
    enviarArquivos(files, history);
  }

  getMsgFileError = (item, verso) => {
    const fileErroFound = this.state.filesError.find(x => x.IdTipoDocumento === item.IdTipoDocumento && x.Verso === verso);
    if (fileErroFound) {
      return fileErroFound.Msg
    } else {
      return "";
    }
  }

  uploadDocumento = async (arquivo) => {
    const result = {
      IdDocumentoArquivo: "",
      ErrorMsg: false
    }
  
    const objPayload = {
      IdTipoArquivo: arquivo.fileType,
      IdTipoDocumento: arquivo.documentType,
      IdGrupoDocumento: 8,
      IdTipoDocumentoImagem: arquivo.imageType,
      Arquivo: arquivo.base64,
      DescricaoDocumento: arquivo.id
    };
  
    await Axios.post("/v1/cliente/documentoarquivo/upload", objPayload)
    .then(({ data }) => {
      result.IdDocumentoArquivo = data.IdDocumentoArquivo;
    })
    .catch((error) => {
      console.log(error);
      result.ErrorMsg = true
    })
    .finally(() => {            
    });    

    return result; 
  }

  getMsgToolTip = (idTipoDocumento, txtDefault) => {
    const { idTipoPessoa } = this.props.renovacaoDocumentos;

    switch(idTipoDocumento) {
      case 3:
        return "Conta de consumo como água, luz, telefone fixo ou gás, emitido nos últimos 90 dias.";
      case 7:
        return "IRPF e Recibo do último ano base, últimos 3 contracheques ou DECORE emitido pelo contador.";      
      case 8:
        return idTipoPessoa === TipoPessoa.PessoaJuridica ? "Procuração vigente para executar operações de câmbio e assinar contratos de câmbio" : 
          "Procuração com firma reconhecida.";
      case 9:
        return "Estatuto ou Contrato Social atualizado Socia PJ Nacional.";
      case 10:
        return "Procuração outorgada ao representante legal no Brasil.";
      case 11:
        return "Faturamento dos últimos 12 meses assinado pelo contador e pelo responsável pela empresa.";
      case 13:
        return "Último Balanço Patrimonial assinado pelo contador e pelo responsável pela empresa ou DEFIS " +
        "(Somente para empresas caraterizadas Simples Nacional) ou Escrituração Contábil Fiscal (ECF) " +
        "e Recibo de Entrega (Somente para empresas na categoria de Lucro Presumido ou Real).";
      case 15:
        return "RG, CNH ou documento de orgão de classe dentro do prazo de validade.";
      case 18:
        return "IRPF e Recibo do último ano base, últimos 3 contracheques ou DECORE emitido pelo contador.";
      default:
        return txtDefault;        
    }
  }

  render() {

    let {
      loadingPage,
      documentosSolicitados,
      tiposDocumentoSolicitados,
      docsObrigatorios,
      docsOpcionais,
      tiposDocObrigatoriosOpcionais
    } = this.props.renovacaoDocumentos;

    if (loadingPage) {
      return <div className="loadingUploadDoc"><Loading /></div>;
    }

    if (documentosSolicitados === null || documentosSolicitados === undefined
      || tiposDocumentoSolicitados === null || tiposDocumentoSolicitados === undefined)
      return <div></div>;

    this.input = [tiposDocumentoSolicitados.length];
    this.inputVerso = [tiposDocumentoSolicitados.length];

    return (
      <section className="container">
        <div className="col">
          <div className="breadcrumbs">
            <ul className="breadcrumbs-list">
              <li className={`breadcrumbs-list-item breadcrumb-active`}></li>

                <li className={`breadcrumbs-list-item-whiteBorder`}></li>
            </ul>
            <h1 className="title">Envio de Documentos</h1>
            <span className="line"></span>
          </div>
        </div>
        <div className="col">
          <span>Prezado cliente <strong>{documentosSolicitados[0].NomeCliente}</strong>, solicitamos o envio dos documentos abaixo:</span>
        </div>    
        {/* Docs Obrigatórios */}
        {docsObrigatorios.length > 0 && (
          <div className="col">
            <b><Label type="title" label="Documentos Solicitados (obrigatórios)" /></b>
          </div>
        )}  
        {tiposDocumentoSolicitados.map((item, index) => {
          if (docsObrigatorios.find(x => x.Documentacao_Id === item.CodigoProcam) !== undefined) {
            return (
              <div key={index}>              
                <div >
                  <FileUpload
                    name="groupUpload"
                    id={`${item.Descricao}`}
                    onChange={this.handleChangeFile}
                    textFile={`${item.Descricao} ${item.DuasFaces ? "(Frente)" : ""}`}
                    subText={this.getMsgToolTip(item.IdTipoDocumento, item.Descricao)}
                    listTypeArquivo={["png", "jpg", "pdf", "jpeg"]}
                    documentType={item.IdTipoDocumento}
                    imageType={item.DuasFaces ? tipoDocImagem.Frente : tipoDocImagem.Comprovante}
                    base64={this.filterFiles(item).length > 0 ? this.filterFiles(item)[0].Base64 : null}
                    documents={this.filterFiles(item)}
                    limit={item.LimiteAnexoSolicitacao}
                    onlyOneArchive={item.LimiteAnexoSolicitacao === 1}
                    errorMessage={this.getMsgFileError(item, false)}
                    disable={this.filterFiles(item).length >= item.LimiteAnexoSolicitacao}
                    required={documentosSolicitados.find(x => x.Documentacao_Id === item.CodigoProcam).Obrigatorio}
                    asyncLoading={this.state.inputsLoading.IdTipoDocumento === item.IdTipoDocumento && !this.state.inputsLoading.Verso}
                  />
    
                  <Table
                    list={this.state.files.filter(x => x.IdTipoDocumento === item.IdTipoDocumento && !x.Verso)}
                    onClick={this.deleteFile}
                  />
    
                  {item.DuasFaces && (
                    <div>
                      <FileUpload
                        name="groupUpload"
                        id={`${item.Descricao}_Verso`}
                        onChange={this.handleChangeFile}
                        textFile={`${item.Descricao} (Verso)`}
                        subText={this.getMsgToolTip(item.IdTipoDocumento, item.Descricao)}
                        listTypeArquivo={["png", "jpeg", "pdf"]}
                        documentType={item.IdTipoDocumento}
                        imageType={tipoDocImagem.Verso}
                        base64={this.filterFiles(item, true).length > 0 ? this.filterFiles(item, true)[0].Base64 : null}
                        documents={this.filterFiles(item, true)}
                        limit={item.LimiteAnexoSolicitacao}
                        onlyOneArchive={item.LimiteAnexoSolicitacao === 1}
                        errorMessage={this.getMsgFileError(item, true)}
                        disable={this.filterFiles(item, true).length >= item.LimiteAnexoSolicitacao}
                        required={documentosSolicitados.find(x => x.Documentacao_Id === item.CodigoProcam).Obrigatorio}
                        asyncLoading={this.state.inputsLoading.IdTipoDocumento === item.IdTipoDocumento && this.state.inputsLoading.Verso}
                      />
    
                      <Table
                        list={this.state.files.filter(x => x.IdTipoDocumento === item.IdTipoDocumento && x.Verso)}
                        onClick={this.deleteFile}
                      />
    
                    </div>
                  )}                  
                </div>  
                <div className="separator"></div>
              </div>       
            )
          } 
          return null;        
        })}
       
        {/* Docs Obrigatórios Opcionais (Caso específico PJ)*/}
        {tiposDocObrigatoriosOpcionais.length > 0 && (
          <div>
           <br/> <br/>
           <div className="fw900">Ou</div>
           <br/>
           <div className="separator"></div>
            {tiposDocObrigatoriosOpcionais.map((item, index) => {
              return (
                <div key={index}>              
                  <div >
                    <FileUpload
                      name="groupUpload"
                      id={`${item.Descricao}`}
                      onChange={this.handleChangeFile}
                      textFile={`${item.Descricao} ${item.DuasFaces ? "(Frente)" : ""}`}
                      subText={this.getMsgToolTip(item.IdTipoDocumento, item.Descricao)}
                      listTypeArquivo={["png", "jpg", "pdf", "jpeg"]}
                      documentType={item.IdTipoDocumento}
                      imageType={item.DuasFaces ? tipoDocImagem.Frente : tipoDocImagem.Comprovante}
                      base64={this.filterFiles(item).length > 0 ? this.filterFiles(item)[0].Base64 : null}
                      documents={this.filterFiles(item)}
                      limit={item.LimiteAnexoSolicitacao}
                      onlyOneArchive={item.LimiteAnexoSolicitacao === 1}
                      errorMessage={this.getMsgFileError(item, false)}
                      disable={this.filterFiles(item).length >= item.LimiteAnexoSolicitacao}
                      required={documentosSolicitados.find(x => x.Documentacao_Id === item.CodigoProcam).Obrigatorio}
                      asyncLoading={this.state.inputsLoading.IdTipoDocumento === item.IdTipoDocumento && !this.state.inputsLoading.Verso}
                    />
      
                    <Table
                      list={this.state.files.filter(x => x.IdTipoDocumento === item.IdTipoDocumento && !x.Verso)}
                      onClick={this.deleteFile}
                    />
      
                    {item.DuasFaces && (
                      <div>
                        <FileUpload
                          name="groupUpload"
                          id={`${item.Descricao}_Verso`}
                          onChange={this.handleChangeFile}
                          textFile={`${item.Descricao} (Verso)`}
                          subText={this.getMsgToolTip(item.IdTipoDocumento, item.Descricao)}
                          listTypeArquivo={["png", "jpeg", "pdf"]}
                          documentType={item.IdTipoDocumento}
                          imageType={tipoDocImagem.Verso}
                          base64={this.filterFiles(item, true).length > 0 ? this.filterFiles(item, true)[0].Base64 : null}
                          documents={this.filterFiles(item, true)}
                          limit={item.LimiteAnexoSolicitacao}
                          onlyOneArchive={item.LimiteAnexoSolicitacao === 1}
                          errorMessage={this.getMsgFileError(item, true)}
                          disable={this.filterFiles(item, true).length >= item.LimiteAnexoSolicitacao}
                          required={documentosSolicitados.find(x => x.Documentacao_Id === item.CodigoProcam).Obrigatorio}
                          asyncLoading={this.state.inputsLoading.IdTipoDocumento === item.IdTipoDocumento && this.state.inputsLoading.Verso}
                        />
      
                        <Table
                          list={this.state.files.filter(x => x.IdTipoDocumento === item.IdTipoDocumento && x.Verso)}
                          onClick={this.deleteFile}
                        />
      
                      </div>
                    )}                  
                  </div>  
                  <div className="separator"></div>
                </div>       
              )   
            })}
          </div>
        )}

        {/* Docs Opcionais */}
        {docsOpcionais.length > 0 && (
          <div className="col">
            <b><Label type="title" label="Documentos Solicitados (opcionais)" /></b>
          </div>
        )}
        {tiposDocumentoSolicitados.map((item, index) => {
          if (docsOpcionais.find(x => x.Documentacao_Id === item.CodigoProcam) !== undefined) {
            return (
              <div key={index}>
               
                <div >
                  <FileUpload
                    name="groupUpload"
                    id={`${item.Descricao}`}
                    onChange={this.handleChangeFile}
                    textFile={`${item.Descricao} ${item.DuasFaces ? "(Frente)" : ""}`}
                    subText={this.getMsgToolTip(item.IdTipoDocumento, item.Descricao)}
                    listTypeArquivo={["png", "jpg", "pdf", "jpeg"]}
                    documentType={item.IdTipoDocumento}
                    imageType={item.DuasFaces ? tipoDocImagem.Frente : tipoDocImagem.Comprovante}
                    base64={this.filterFiles(item).length > 0 ? this.filterFiles(item)[0].Base64 : null}
                    documents={this.filterFiles(item)}
                    limit={item.LimiteAnexoSolicitacao}
                    onlyOneArchive={item.LimiteAnexoSolicitacao === 1}
                    errorMessage={this.getMsgFileError(item, false)}
                    disable={this.filterFiles(item).length >= item.LimiteAnexoSolicitacao}
                    required={documentosSolicitados.find(x => x.Documentacao_Id === item.CodigoProcam).Obrigatorio}
                    asyncLoading={this.state.inputsLoading.IdTipoDocumento === item.IdTipoDocumento && !this.state.inputsLoading.Verso}
                  />
    
                  <Table
                    list={this.state.files.filter(x => x.IdTipoDocumento === item.IdTipoDocumento && !x.Verso)}
                    onClick={this.deleteFile}
                  />
    
                  {item.DuasFaces && (
                    <div>
                      <FileUpload
                        name="groupUpload"
                        id={`${item.Descricao}_Verso`}
                        onChange={this.handleChangeFile}
                        textFile={`${item.Descricao} (Verso)`}
                        subText={this.getMsgToolTip(item.IdTipoDocumento, item.Descricao)}
                        listTypeArquivo={["png", "jpeg", "pdf"]}
                        documentType={item.IdTipoDocumento}
                        imageType={tipoDocImagem.Verso}
                        base64={this.filterFiles(item, true).length > 0 ? this.filterFiles(item, true)[0].Base64 : null}
                        documents={this.filterFiles(item, true)}
                        limit={item.LimiteAnexoSolicitacao}
                        onlyOneArchive={item.LimiteAnexoSolicitacao === 1}
                        errorMessage={this.getMsgFileError(item, true)}
                        disable={this.filterFiles(item, true).length >= item.LimiteAnexoSolicitacao}
                        required={documentosSolicitados.find(x => x.Documentacao_Id === item.CodigoProcam).Obrigatorio}
                        asyncLoading={this.state.inputsLoading.IdTipoDocumento === item.IdTipoDocumento && this.state.inputsLoading.Verso}
                      />
    
                      <Table
                        list={this.state.files.filter(x => x.IdTipoDocumento === item.IdTipoDocumento && x.Verso)}
                        onClick={this.deleteFile}
                      />
    
                    </div>
                  )}                  
                </div>  
                <div className="separator"></div>
              </div>       
            )
          } 
          return null;        
        })}

        <div className="groupEnviar">
          <button 
            className="buttonEnviar"
            onClick={() => this.enviar()}
          >
            Enviar
          </button>
        </div>
      </section>
    );
  }
}

export default RenovacaoDocumentos;

